import {
  maxLength,
  requiredIf,
  minLength,
  integer
} from 'vuelidate/lib/validators';

export default {
  pin: {
    required: requiredIf(function (vm) {
      return !vm.failureReasonError;
    }),
    integer,
    maxLength: maxLength(6),
    minLength: minLength(6)
  }
};
